export const SPRAY_EVENT_WIZARD_SET_STEP = 'SPRAY_EVENT_WIZARD_SET_STEP';

export const SPRAY_EVENT_WIZARD_SCHEDULE_STEP = 0;
export const SPRAY_EVENT_WIZARD_APPLICATION_STEP = 1;
export const SPRAY_EVENT_WIZARD_EQUIPMENT_STEP = 2;
export const SPRAY_EVENT_WIZARD_PRODUCT_STEP = 3;
export const SPRAY_EVENT_WIZARD_SUMMARY_STEP = 4;
